<template>
	<div class="notification" :class="tipo">
		<button class="delete" @click="removeNotification"></button>
		<span class="icon" v-if="notification.icon"><font-awesome-icon size="1x" :icon="notification.icon"/></span>
		<span style="vertical-align: top;" v-html="notification.message" @click="btnReload(notification)"></span>
	</div>
</template>

<script>
	import { mapActions } from "vuex";

	export default {
		name: "NotificationBar",
		props: {
			notification: {
      type: Object, // String, Number, Boolean, Function, Object, Array
      required: true
  }
},
data() {
	return {
		timeout: null
	};
},
mounted() {
	if (this.notification.timeout != "never") {
		this.timeout = setTimeout(() => {
			this.remove(this.notification);
		}, (this.notification.timeout) ? this.notification.timeout : 5000);
	}
},
beforeDestroy() {
	clearTimeout(this.timeout);
},
computed: {
	tipo() {
		let clase = "";
		switch (this.notification.type) {
			case "error":
			clase = "is-danger";
			break;
			case "success":
			clase = "is-success";
			break;
			case "alert":
			clase = "is-warning";
			break;
			default:
			clase = "is-info";
			break;
		}
		return clase;
	}
},
methods: {
	removeNotification() {
		this.remove(this.notification);
	},
	btnReload(n){
		if (n.reload != undefined) {
			window.location.reload()
		}
	},
	...mapActions("notification", ["remove"])
}
};
</script>

<style lang="css" scoped>
.notification {
	margin: 0px 0px 1.5em;
	opacity: 0.9;
	font-size: 0.9em;
}
.icon{
	margin-right: 0.5em;
}
</style>
